"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageDetailsModel = void 0;
const StorageDetailsModel = {
    type: Object,
    schema: {
        roomTemp: { type: String },
        total: { type: Number },
        maxWeight: { type: Number },
        width: { type: Number },
        length: { type: Number },
        height: { type: Number },
    },
};
exports.StorageDetailsModel = StorageDetailsModel;
